import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { KktFindInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-find.dto';
import type { KktFormInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-form.dto';
import type { KktPageInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-page.dto';
import type { KktQueryInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-query.dto';

import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KktService extends BaseService {
  protected baseUrl = '/fdo/kkt';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findMany(queryParams?: KktQueryInterface): Observable<KktPageInterface> {
    return this.http.get<KktPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public createOne(body: KktFormInterface): Observable<KktFindInterface> {
    return this.http.post<KktFindInterface>(`${this.baseUrl}`, body);
  }
}
